export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 2,
				text: "The lecturer presented the content appropriately.",
			},
			{
				id: 3,
				text: "I was able to follow the pace of the lecturer.",
			},
			{
				id: 4,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 5,
				text: "The lecturer provided the opportunity to ask questions.",
			},
			{
				id: 6,
				text: "The lecturer was always well prepared.",
			},
			{
				id: 7,
				text: "The lecturer was able to make the content accessible.",
			},
			{
				id: 8,
				text: "It was important to the lecturer that the participants benefitted from the course.",
			},
			{
				id: 9,
				text: "The lecturer taught the course in an interesting way.",
			},
			{
				id: 10,
				text: "The materials and the media used by the lecturer were very helpful.",
			},
			{
				id: 11,
				text: "The range of support offered by the lecturer (e.g. office hours) was adequate.",
			},
			{
				id: 12,
				text: "The educational objectives were well defined from the beginning.",
			},
			{
				id: 13,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 14,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 15,
				text: "I gained important insights in the course.",
			},
			{
				id: 16,
				text: "I further developed important competencies in the course.",
			},
			{
				id: 17,
				text: "The competencies acquired in the course are of great relevance for my academic development.",
			},
			{
				id: 18,
				text: "The degree of difficulty of the course was adequate.",
			},
			{
				id: 19,
				text: "The amount of the content was adequate.",
			},
			{
				id: 20,
				text: "The pace of the course was adequate.",
			},
			{
				id: 21,
				text: "The requirements of the course were adequate.",
			},
			{
				id: 22,
				text: "The amount of time required for the course (including preparation and follow-up) was appropriate.",
			},
			{
				id: 23,
				text: "The course was too difficult for me.",
			},
			{
				id: 24,
				text: "I put a lot of time into the preparation and follow-up work of the course.",
			},
			{
				id: 25,
				text: "I prepared the texts/materials of the course regularly.",
			},
			{
				id: 26,
				text: "On my own initiative, I consulted additional material related to the content of the course.",
			},
			{
				id: 27,
				text: "I put more time into this course than into comparable courses.",
			},
			{
				id: 28,
				text: "I participated in the course actively.",
			},
			{
				id: 29,
				text: "The work in the seminar (discussions, group work, text work, homework etc.) deepened my understanding of the contents.",
			},
			{
				id: 30,
				text: "The seminar clarified the relevance of its contents.",
			},
			{
				id: 31,
				text: "The seminar encouraged me to think about the contents addressed",
			},
			{
				id: 32,
				text: "The seminar inspired me to reflect the addressed topics critically.",
			},
			{
				id: 33,
				text: "The seminar motivated me to occupy myself with the contents of the course.",
			},
			{
				id: 34,
				text: "The collaborative work in the seminar was productive.",
			},
			{
				id: 35,
				text: "The lecturer was able to add information to oral presentations in a proper way.",
			},
			{
				id: 36,
				text: "The presentation style of oral presentations was appealing.",
			},
			{
				id: 37,
				text: "The content of oral presentations was of high quality.",
			},
			{
				id: 38,
				text: "I learned a lot from the oral presentation given by other participants.",
			},
			{
				id: 39,
				text: "I learned a lot about the addressed contents through my own oral presentation.",
			},
			{
				id: 40,
				text: "The lecturer supported the preparation of the oral presentation very well.",
			},
			{
				id: 41,
				text: "The feedback concerning my oral presentation was helpful.",
			},
			{
				id: 42,
				text: "Overall, this was a good course.",
			},
			{
				id: 43,
				text: "I learned a lot in this course.",
			},
			{
				id: 44,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 45,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 46,
				text: "Further remarks",
			},
		],
	},
];
